/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ plan: NonNullable<unknown>, date: NonNullable<unknown> }} Plan_Tab_Downgrade_InfoInputs */



/**
* | output |
* | --- |
* | "Downgrades to {plan} on {date}" |
*
* @param {Plan_Tab_Downgrade_InfoInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const plan_tab_downgrade_info = /** @type {((inputs: Plan_Tab_Downgrade_InfoInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Tab_Downgrade_InfoInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Wechsel auf ${i?.plan} am ${i?.date}`)
	return /** @type {LocalizedString} */ (`Downgrades to ${i?.plan} on ${i?.date}`)
});